// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1Fndc","topBottomGutter":"Layout_topBottomGutter__2Fg6i"};